/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M0 3c0-1.6568 1.3432-3 3-3h6c1.6569 0 3 1.3432 3 3v6c0 1.6569-1.3431 3-3 3H3c-1.6568 0-3-1.3431-3-3V3Zm3-.75h6a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75H3A.75.75 0 0 1 2.25 9V3A.75.75 0 0 1 3 2.25ZM0 16.5c0-1.6569 1.3432-3 3-3h6c1.6569 0 3 1.3431 3 3V21c0 1.6569-1.3431 3-3 3H3c-1.6568 0-3-1.3431-3-3v-4.5Zm3-.75h6a.75.75 0 0 1 .75.75V21a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 .75-.75ZM16.5 10.5c-1.6569 0-3 1.3431-3 3V21c0 1.6569 1.3431 3 3 3H21c1.6569 0 3-1.3431 3-3v-7.5c0-1.6569-1.3431-3-3-3h-4.5Zm4.5 2.25h-4.5a.75.75 0 0 0-.75.75V21a.75.75 0 0 0 .75.75H21a.75.75 0 0 0 .75-.75v-7.5a.75.75 0 0 0-.75-.75ZM13.5 3c0-1.6568 1.3431-3 3-3H21c1.6569 0 3 1.3432 3 3v3c0 1.6569-1.3431 3-3 3h-4.5c-1.6569 0-3-1.3431-3-3V3Zm3-.75H21a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1-.75-.75V3a.75.75 0 0 1 .75-.75Z"
    clipRule="evenodd"
  />,
  'MenuSummary'
);
